import { render, staticRenderFns } from "./CeldaSwitch.vue?vue&type=template&id=37fe1a16&scoped=true"
import script from "./CeldaSwitch.vue?vue&type=script&lang=js"
export * from "./CeldaSwitch.vue?vue&type=script&lang=js"
import style0 from "./CeldaSwitch.vue?vue&type=style&index=0&id=37fe1a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe1a16",
  null
  
)

export default component.exports